import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import ResponsiveImage from "./responsiveimage";

export default function BlogPost({ baseURL = "https://gantasoft.in/rankridgecollege/dev/v1" }) {
  const { slug } = useParams();
  const api = useMemo(() => axios.create({ baseURL }), [baseURL]);
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=> {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/posts", { params: { slug } });
        setPost(data?.item || null);
      } finally { setLoading(false); }
    })();
  }, [api, slug]);

  if (loading) return <div className="max-w-3xl mx-auto p-4">Loading…</div>;
  if (!post)   return <div className="max-w-3xl mx-auto p-4">Not found.</div>;

  return (
    <article className="max-w-3xl mx-auto px-4 py-10">
      <Link to="/blog" className="text-sm text-green-700 hover:underline">← Back to Blog</Link>

      <h1 className="mt-4 text-3xl md:text-4xl font-extrabold">{post.title}</h1>

      <div className="mt-3 text-sm text-gray-500 flex flex-wrap items-center gap-2">
        {post.author_name && <span>By {post.author_name}</span>}
        {post.published_at && <><span>•</span><span>{new Date(post.published_at).toLocaleDateString()}</span></>}
        <span>•</span><span>{post.reading_time_min || 1} min read</span>
        <span>•</span><span>{post.view_count ?? 0} views</span>
      </div>

      {post.cover_image && (
        <div className="mt-6 rounded-2xl overflow-hidden shadow">
           <ResponsiveImage
  avif={"https://gantasoft.in/rankridgeschool/dev"+ post.cover_image}
  webp={"https://gantasoft.in/rankridgeschool/dev"+ post.cover_image}
  srcFallback={"https://gantasoft.in/rankridgeschool/dev"+ post.cover_image}   // 👈 main fallback
  alt={post.title}
  eager // eager for LCP
  className="w-full h-auto object-contain"
/>
         
          {/* <img src={"https://gantasoft.in/rankridgeschool/dev"+post.cover_image} alt={post.title} className="w-full h-auto object-cover" /> */}
        </div>
      )}

      {/* BODY: ensure backend sanitizes HTML; here we trust server content */}
      <div className="prose prose-lg max-w-none mt-6" dangerouslySetInnerHTML={{ __html: post.body_html || '' }} />

      {/* Tags */}
      {(post.tags||[]).length > 0 && (
        <div className="mt-8 flex flex-wrap gap-2">
          {post.tags.map(t => (
            <span key={t.tag_id} className="text-xs bg-gray-100 rounded px-2 py-1">#{t.name}</span>
          ))}
        </div>
      )}
    </article>
  );
}
